"use strict";

module.exports = function () {
  return this.data;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/computed/table-data.js